import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VolumeDown"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.8249 7.99499L17.6849 8.99999C19.1481 10.735 19.0902 13.2881 17.5499 14.955L18.6524 15.975C20.7054 13.7501 20.7794 10.3444 18.8249 8.03249V7.99499ZM15 22.5C14.7996 22.4992 14.6078 22.4181 14.4675 22.275L8.7525 16.5H3.75C3.33579 16.5 3 16.1642 3 15.75V8.24999C3 7.83578 3.33579 7.49999 3.75 7.49999H8.7525L14.4675 1.72499C14.76 1.4342 15.2325 1.4342 15.525 1.72499C15.6663 1.86346 15.7472 2.05216 15.75 2.24999V21.75C15.75 22.1642 15.4142 22.5 15 22.5ZM4.5 15H9C9.21863 14.9986 9.42993 15.0788 9.5925 15.225L14.25 19.9275V4.07249L9.5925 8.77499C9.42993 8.92118 9.21863 9.00142 9 8.99999H4.5V15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/VolumeDown.vue"]]);
